export const tipoDeInvalidacion = [
  { value: 1, label: 'Error en la Información del Documento Tributario Electrónico a invalidar.' },
  { value: 2, label: 'Rescindir de la operación realizada.' },
  { value: 3, label: 'Otro' },
];

export const tipoDocResponsable = [
  { value: '36', label: 'NIT' },
  { value: '13', label: 'DUI' },
  { value: '37', label: 'Otro' },
  { value: '03', label: 'Pasaporte' },
  { value: '02', label: 'Carnet de Residente' },
];
